module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./ServiceCodeView.js"));
	}, "ServiceCodeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ServiceCodeView!./src/pages/Shop/Member/Personal/ServiceCode/ServiceCodeView.js
// module id = 961
// module chunks = 438